import { IGetListParams } from '../../base/base.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { EmployeeSkillsService, IEmployeeSkill } from '../../services/employeeSkills.service';

class DashboardSkillsController {
    private skills: IEmployeeSkill[];
    constructor(private EmployeeSkillsService: EmployeeSkillsService) {
        "ngInject";
    }

    public $onInit = () => {
        this.getShift();
    }

    public getShift = () => {
        this.EmployeeSkillsService.getList({sortfield: 'end', sortorder: 'ASC'}).then((skills) => {
            this.skills = skills.value;
        })
    }

    public isExpired = (date) => {
        if (moment(date) <= moment()) {
            return true;
        } else {
            return false;
        }
    }
}

export const dashboardSkillsComponent = {
    controller: DashboardSkillsController,
    template: require('./dashboard.skills.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.skills.component.ts